/**
 * Pure helpers for the RegionSwitch control (DESIGN.md Aneks M003 §R1). No
 * DOM access — kept separate from ui/RegionSwitch.ts so the roving-tabindex
 * math and coverage-sublabel text are unit-testable without jsdom, matching
 * the rest of src/lib/.
 */
import type { RegionId } from "./sources";

/**
 * Next roving-tabindex segment index for ArrowLeft/Right (or Up/Down)
 * within a fixed-size group, wrapping around both ends. `direction` is +1
 * (next) or -1 (previous). DESIGN.md §R1: arrows move focus WITHOUT
 * activating — this only computes the target index, activation is a
 * separate explicit Enter/Space action.
 */
export function nextSegmentIndex(current: number, direction: 1 | -1, count: number): number {
  if (count <= 0) return 0;
  return (current + direction + count) % count;
}

/**
 * Coverage sublabel text for the segmented control (§R1 "Sublabel
 * pokrycia"): null for "us" (no sublabel shown); "NIEMCY · DWD" for "eu-de",
 * narrowed to just "NIEMCY" at the ≤360px compact breakpoint.
 */
export function coverageSublabelText(region: RegionId, compact: boolean): string | null {
  if (region !== "eu-de") return null;
  return compact ? "NIEMCY" : "NIEMCY · DWD";
}
